// @flow

const BASE_URL = '/api/adressevaelger';

function parseFloor(v) {
  return v === null ? 0 : v === 'st' ? 0 : Number(v);
}

function parseDoor(v) {
  return v === null ? '' : String(v);
}

function sortUnitsRaw(a, b) {
  const a1 = parseFloor(a.etage);
  const b1 = parseFloor(b.etage);

  if (a1 === b1) {
    const a2 = parseDoor(a.dør);
    const b2 = parseDoor(b.dør);

    return a2 > b2 ? 1 : a2 < b2 ? -1 : 0;
  }

  return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
}

function filterValidUnitsRaw(unit) {
  return unit.etage || unit.dør;
}

type Result = {
  label: string,
  value: string,
  type: string,
  id: string,
  data?: any
};

export function fetchAddress(q) {
  return fetch(
    `${BASE_URL}/adresser/soeg?q=${encodeURIComponent(q)}`
  )
    .then(response => response.json())
    .then(body => {
      if (body.status !== 'ok' || !Array.isArray(body.fund)) {
        return [];
      }

      return body.fund.slice(0, 10).map(item => {
        if (item.type === 'vejnavn') {
          return {
            label: item.titel,
            value: item.vejNavn || item.titel,
            type: 'vejnavn',
            id: item.vejNavn || item.titel
          };
        }

        if (item.type === 'navngivenvejpostnummer') {
          return {
            label: item.titel,
            value: item.id || item.titel,
            type: 'vejnavn',
            id: item.id || item.titel
          };
        }

        if (item.type === 'husnummer') {
          return {
            label: item.titel,
            value: `${BASE_URL}/husnumre/${encodeURIComponent(item.id)}`,
            type: 'adgangsadresse',
            id: item.id
          };
        }

        if (item.type === 'adresse') {
          return {
            label: item.titel,
            value: `${BASE_URL}/adresser/${encodeURIComponent(item.id)}`,
            type: 'address',
            id: item.id
          };
        }

        return null;
      }).filter(Boolean);
    });
}

export function fetchStreets(q: string): Promise<Array<Result>> {
  return fetch(
    `${BASE_URL}/soeg?q=${encodeURIComponent(q)}`
  )
    .then(response => response.json())
    .then(body => {
      if (body.status !== 'ok' || !Array.isArray(body.fund)) {
        return [];
      }

      return body.fund
        .filter(
          item =>
            item.type === 'vejnavn' ||
            item.type === 'navngivenvejpostnummer'
        )
        .map(item => ({
          label: item.titel,
          value: item.vejNavn || item.vejnavn || item.titel,
          type: 'vejnavn',
          id: item.id || item.vejNavn || item.vejnavn || item.titel
        }));
    });
}

export function fetchEntryPoints(q: string): Promise<Array<Result>> {
  return fetch(
    `${BASE_URL}/husnumre/soeg?q=${encodeURIComponent(q)}`
  )
    .then(response => response.json())
    .then(body => {
      if (body.status !== 'ok' || !Array.isArray(body.fund)) {
        return [];
      }

      return body.fund
        .filter(item => item.type === 'husnummer')
        .map(item => ({
          label: item.titel,
          value: item.id,
          type: 'adgangsadresse',
          id: item.id
        }));
    });
}

export function fetchUnits(q: string): Promise<Array<Result>> {
  return fetch(
    `${BASE_URL}/husnumre/${encodeURIComponent(q)}/adresser`
  )
    .then(response => response.json())
    .then(body => {
      if (body.status !== 'ok' || !Array.isArray(body.adresser)) {
        return [];
      }

      return body.adresser
        .map(item => ({
          ...item,
          id: item.id_lokalid,
          etage: item.etagebetegnelse,
          dør: item.doerbetegnelse
        }))
        .filter(filterValidUnitsRaw)
        .sort(sortUnitsRaw);
    })
    .then(body =>
      body.map(item => ({
        label: item.adressebetegnelse,
        value: `${BASE_URL}/adresser/${encodeURIComponent(item.id)}`,
        type: 'unit',
        id: item.id,
        data: item
      }))
    );
}